"use strict";

var _slicedToArray = require("/Users/alecresende/code/visual-sampler/sequencer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _defineProperty = require("/Users/alecresende/code/visual-sampler/sequencer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HTML = void 0;

var jsx_runtime_1 = require("react/jsx-runtime");

var react_1 = require("react");

var MediaLoader_1 = require("./MediaLoader");

var RendererConfig_1 = require("./RendererConfig");

var HTMLRenderer = function HTMLRenderer(requestProps) {
  var _a, _b;

  var getStyles = requestProps.getStyles,
      request = requestProps.request,
      theme = requestProps.theme;

  var _MediaLoader_1$useMed = MediaLoader_1.useMediaObjectProps(_objectSpread({
    uri: ((_a = request.media.content) === null || _a === void 0 ? void 0 : _a.uri) || ((_b = request.media.animation) === null || _b === void 0 ? void 0 : _b.uri),
    preferredIPFSGateway: theme.preferredIPFSGateway
  }, requestProps)),
      props = _MediaLoader_1$useMed.props,
      loading = _MediaLoader_1$useMed.loading,
      error = _MediaLoader_1$useMed.error;

  var _react_1$useState = react_1.useState(function () {
    return window.innerHeight;
  }),
      _react_1$useState2 = _slicedToArray(_react_1$useState, 2),
      windowHeight = _react_1$useState2[0],
      setWindowHeight = _react_1$useState2[1];

  react_1.useEffect(function () {
    var resizeHandler = function resizeHandler() {
      setWindowHeight(window.innerHeight);
    };

    document.addEventListener("resize", resizeHandler);
    return function () {
      document.removeEventListener("resize", resizeHandler);
    };
  });
  return jsx_runtime_1.jsx(MediaLoader_1.MediaLoader, Object.assign({
    getStyles: getStyles,
    loading: loading,
    error: error
  }, {
    children: jsx_runtime_1.jsx("iframe", Object.assign({
      sandbox: "allow-scripts",
      height: Math.floor(windowHeight * 0.6),
      width: "100%",
      style: {
        border: 0
      }
    }, props), void 0)
  }), void 0);
};

exports.HTML = {
  getRenderingPreference: function getRenderingPreference(request) {
    var _a, _b, _c, _d, _e, _f;

    if (((_b = (_a = request.media.content) === null || _a === void 0 ? void 0 : _a.type) === null || _b === void 0 ? void 0 : _b.startsWith("text/html")) || ((_d = (_c = request.media.content) === null || _c === void 0 ? void 0 : _c.type) === null || _d === void 0 ? void 0 : _d.startsWith("application/pdf")) || ((_f = (_e = request.media.animation) === null || _e === void 0 ? void 0 : _e.type) === null || _f === void 0 ? void 0 : _f.startsWith("text/html"))) {
      return request.renderingContext === "FULL" ? RendererConfig_1.RenderingPreference.PRIORITY : RendererConfig_1.RenderingPreference.INVALID;
    }

    return RendererConfig_1.RenderingPreference.INVALID;
  },
  render: HTMLRenderer
};